import { memo, useMemo } from 'react';
import { ButtonSize } from "../../../button";
import UserDropdown from "../user-dropdown/user-dropdown";
import { useMenuContext } from "../../mega-menu-provider";
import { AuthLinks } from "../auth-links/auth-links";
import { HighlightedMobileLink, RightNavigationContainer } from "./right-navigation.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var RightNavigation = function RightNavigation(_ref) {
  var isMinimalMenu = _ref.isMinimalMenu,
    userMenuItems = _ref.userMenuItems,
    user = _ref.user,
    ctas = _ref.ctas,
    highlightedMobileLink = _ref.highlightedMobileLink;
  var _useMenuContext = useMenuContext(),
    isMenuScrolled = _useMenuContext.isMenuScrolled,
    isMobileMenuOpen = _useMenuContext.isMobileMenuOpen,
    isUserDropdownVisible = _useMenuContext.isUserDropdownVisible,
    onUserMenuClick = _useMenuContext.onUserMenuClick,
    onUserMenuItemClick = _useMenuContext.onUserMenuItemClick,
    palette = _useMenuContext.palette;
  var shouldShowHighlightedLink = useMemo(function () {
    if (!highlightedMobileLink || !isMenuScrolled || isMobileMenuOpen) {
      return false;
    }
    return isUserDropdownVisible ? !highlightedMobileLink.isSignupLink : true;
  }, [isUserDropdownVisible, isMobileMenuOpen, highlightedMobileLink, isMenuScrolled]);
  return /*#__PURE__*/_jsxs(RightNavigationContainer, {
    children: [!isMinimalMenu && highlightedMobileLink && /*#__PURE__*/_jsx(HighlightedMobileLink, {
      isVisible: shouldShowHighlightedLink,
      href: highlightedMobileLink.link,
      size: ButtonSize.Small,
      palette: palette,
      children: highlightedMobileLink.label
    }), isUserDropdownVisible ? /*#__PURE__*/_jsx(UserDropdown, {
      menuItems: userMenuItems,
      user: user,
      onUserMenuClick: onUserMenuClick,
      onUserMenuItemClick: onUserMenuItemClick
    }) : /*#__PURE__*/_jsx(AuthLinks, {
      isMinimalMenu: isMinimalMenu,
      ctas: ctas,
      palette: palette,
      isMobileMenuOpen: isMobileMenuOpen
    })]
  });
};
export default /*#__PURE__*/memo(RightNavigation);